import React from 'react'

import { 
    SectionDiv, 
    DeleteApplicationButtonDiv,
    DeleteApplicationButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux dispatch and selector

import { useDispatch } from "react-redux"

import { showAlert } from '../../../Redux/Slices/AppViewerSlice'

function DeleteSection(props){
    const dispatch = useDispatch()

    function deleteApplication(e){
        dispatch(showAlert({alertType: 'delete'}))
    }

    return (
        <SectionDiv id = {props.name}>
            <DeleteApplicationButtonDiv>
                <DeleteApplicationButton onClick={deleteApplication}>Delete Application</DeleteApplicationButton>
            </DeleteApplicationButtonDiv>
        </SectionDiv>
    )
}

export default DeleteSection